import { captureMessage } from '@sentry/nextjs'
import Cookies from 'js-cookie'
import { useEffect } from 'react'

import { COOKIE_NAMES } from 'lib/constants'
import { callFunctionProbabilistically } from 'utils/callFunctionProbabilistically'
import { getBotInfo } from 'utils/getBotInfo'

const doBotDetectionAlerting = () => {
  const { userAgent } = navigator
  const userIpAddress = Cookies.get(COOKIE_NAMES.userIpAddress)

  const { isBot, isIssuerBot, issuerBotName } = getBotInfo()

  const botSentryAlertContext: Parameters<typeof captureMessage>[1] = {
    contexts: { context: { userAgent, userIpAddress } },
  }

  if (isBot) {
    callFunctionProbabilistically({
      functionToCall: () => {
        captureMessage('Bot detected', botSentryAlertContext)
      },
      probabilityOfCalling: 0.05,
    })
  }

  if (isIssuerBot) {
    captureMessage(
      `Issuer bot detected: ${issuerBotName}`,
      botSentryAlertContext,
    )
  }
}

export const useBotDetectionAlerting = (): void => {
  useEffect(() => {
    doBotDetectionAlerting()
  }, [])
}
